document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    abortController: null,
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout(window.matchMedia('(min-width: 768px)').matches);
      this._setListeners();
    },
    _initLayout(isDesktop) {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (isDesktop) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      // Listen for color filter changes
      this.$el.addEventListener('colorFilterChanged', (event) => {
        this.onSubmit(250);
      });

      // Optimistic chip remove: uncheck matching input, then refetch
      this.$el.addEventListener('click', (event) => {
        const chipBtn = event.target.closest('[data-optimistic-chip]');
        if (!chipBtn) return;
        event.preventDefault();
        const li = chipBtn.closest('[data-optimistic-name]');
        if (!li) return;
        const name = li.getAttribute('data-optimistic-name');
        const value = li.getAttribute('data-optimistic-value') || '';
        const form = document.getElementById('FacetFiltersForm');
        if (!form || !name) return;
        const input = Array.from(form.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(name)}"]`))
          .find((el) => el.value === value);
        if (input) {
          input.checked = false;
          this.onSubmit(250);
        }
      });

      installMediaQueryWatcher('(min-width: 768px)', (matches) => this._initLayout(matches));
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 250) {
      clearTimeout(this.t);
      this._paintOptimistic();
      this._abortInFlight();

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) {
          const sortSelect = document.getElementById('FormSelectFilter');
          if (sortSelect) sortSelect.blur();
        }
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
        maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      clearTimeout(this.t);
      this._abortInFlight();
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _abortInFlight() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    },
    _escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    _chipLabelForInput(input) {
      const label = input.id
        ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`)
        : input.closest('label');
      if (label) {
        const clone = label.cloneNode(true);
        clone.querySelectorAll('input, svg, style, script, .color-filter').forEach((node) => node.remove());
        const text = clone.textContent.replace(/\s+/g, ' ').trim();
        if (text) return text;
      }
      return input.getAttribute('aria-label') || input.value || '';
    },
    _paintOptimistic() {
      this.loading = true;
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.setAttribute('aria-busy', 'true');
      this._syncOptimisticActiveTags();
    },
    _syncOptimisticActiveTags() {
      const form = document.getElementById('FacetFiltersForm');
      if (!form) return;

      const chips = [];
      form.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)').forEach((input) => {
        if (!input.name || input.name === 'sort_by') return;
        const text = this._chipLabelForInput(input);
        if (!text) return;
        chips.push({ text, name: input.name, value: input.value });
      });

      const containers = document.querySelectorAll('#active-filter-tag, #active-filter-tag-mobile');
      containers.forEach((container) => {
        const existingList = container.querySelector('ul.active-filter');
        const listClass = existingList?.className || 'active-filter flex flex-wrap gap-2 mt-4 mb-4';
        const existingChipBtn = container.querySelector('ul.active-filter li button:not(.underline)');
        const btnClass = existingChipBtn?.className
          || 'px-3 py-1.5 cursor-pointer flex items-center bg-[rgba(var(--colors-text),0.05)] rounded';
        const clearLi = container.querySelector('ul.active-filter > li:last-child button.underline')?.closest('li');

        if (chips.length === 0) {
          container.innerHTML = '';
          return;
        }

        let html = `<ul class="${listClass}">`;
        chips.forEach((chip) => {
          html += `<li data-optimistic-name="${this._escapeHtml(chip.name)}" data-optimistic-value="${this._escapeHtml(chip.value)}">`
            + `<button type="button" class="${btnClass}" data-optimistic-chip>`
            + `<span class="active-filter-control">${this._escapeHtml(chip.text)}</span>`
            + `<span class="md:w-2.5 md:h-2.5 md:min-w-[10px] min-w-[8px] ml-2 rtl:mr-2 rtl:ml-0 w-2 h-2 cursor-pointer inline-block" aria-hidden="true">×</span>`
            + `</button></li>`;
        });
        if (clearLi) html += clearLi.outerHTML;
        html += '</ul>';
        container.innerHTML = html;
      });
    },
    _clearBusyState() {
      this.loading = false;
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.removeAttribute('aria-busy');
    },
    _renderPage(searchParams, updateURLHash = true) {
      this._abortInFlight();
      this.searchParamsPrev = searchParams;
      this.loading = true;
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.setAttribute('aria-busy', 'true');
      
      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        if (updateURLHash) this._updateURLHash(searchParams);
        return;
      }

      this.abortController = new AbortController();
      const requestParams = searchParams;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url, { signal: this.abortController.signal })
        .then(response => response.text())
        .then((responseText) => {
          if (requestParams !== this.searchParamsPrev) return;
          this.cachedResults[requestParams] = responseText;
          this._renderResults(responseText);
        })
        .catch((error) => {
          if (error?.name === 'AbortError') return;
          this._clearBusyState();
          console.error(error);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _asDoc(html) {
      if (html && html.querySelector) return html;
      return new DOMParser().parseFromString(html, 'text/html');
    },
    _renderResults(html) {
      const parsedHTML = this._asDoc(html);
      this._renderFilters(parsedHTML);
      this._renderProductGridContainer(parsedHTML);
      this._renderProductCount(parsedHTML);
      this._clearBusyState();
    },
    _renderFilters(html) {
      const parsedHTML = this._asDoc(html);
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")

      if (activeTag) {
        const nextActive = parsedHTML.getElementById("active-filter-tag");
        if (nextActive) activeTag.innerHTML = nextActive.innerHTML;
      }
      const activeTagMobile = document.getElementById("active-filter-tag-mobile");
      if (activeTagMobile) {
        const nextMobile = parsedHTML.getElementById("active-filter-tag-mobile");
        if (nextMobile) activeTagMobile.innerHTML = nextMobile.innerHTML;
      }
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      const parsedHTML = this._asDoc(html);
      const src = parsedHTML.getElementById('ProductGridContainer');
      const dest = document.getElementById('ProductGridContainer');
      if (src && dest) dest.innerHTML = src.innerHTML;
      if (typeof window.renderKlaviyoStarWidgets === 'function') {
        const run = () => window.renderKlaviyoStarWidgets();
        if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 800 });
        else setTimeout(run, 1);
      }
    },
    _renderProductCount(html) {
      const parsedHTML = this._asDoc(html);
      const productCountEl = parsedHTML.getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        if (container) container.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});
